/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    SagaPlusHeader: {
        id: 'SagaPlusTermsModal.SagaPlusHeader',
        defaultMessage: '3-year Fixed Price terms and conditions'
    },
    FixedPriceBullet: {
        id: 'SagaPlusTermsModal.FixedPriceBullet',
        defaultMessage: 'Saga’s 3–year Fixed Price is offered to you for a 3-year period. Your total price (including the arrangement fee and the price of any additional cover options taken out at the start of your 3-year Fixed Price period) is the price at which your policy will be set, dependent on these Saga 3-year Fixed Price terms and conditions.'
    },
    CancellationBullet1: {
        id: 'SagaPlusTermsModal.CancellationBullet1',
        defaultMessage: 'The 3-year Fixed Price applies to a policy taken out at the start of the 3-year Fixed Price period and renewed for the following two years. You may cancel your policy at any time, in accordance with the terms of your '
    },
    CancellationBullet2: {
        id: 'SagaPlusTermsModal.CancellationBullet2',
        defaultMessage: ', and your 3-year Fixed Price will end. On cancellation, the arrangement fee is non-refundable; however, no cancellation fee will be charged.'
    },
    LowerPriceBullet: {
        id: 'SagaPlusTermsModal.LowerPriceBullet',
        defaultMessage: 'During the 3-year Fixed Price period, if Saga is able to offer you a lower price than the price provided to you at the start of your 3-year Fixed Price period, then the lower price would apply for any remaining renewal periods.'
    },
    PriceChangeBullet: {
        id: 'SagaPlusTermsModal.PriceChangeBullet',
        defaultMessage: 'The price of your insurance may change during the 3-year Fixed Price period if:'
    },
    PriceChangeAmendmentsBullet: {
        id: 'SagaPlusTermsModal.PriceChangeAmendmentsBullet',
        defaultMessage: 'You make any changes to your policy or change your cover options at any time. If any change you make leads to a change in the price of your policy, this price change will take effect at the time that you make the change and will continue for any remaining renewal periods.'
    },
    PriceChangeClaimsBulletPrivateHome: {
        id: 'SagaPlusTermsModal.PriceChangeClaimsBulletPrivateHome',
        defaultMessage: 'You make a claim for accidental damage or accidental loss or any claim made under the personal belongings section of your cover. Your price will not be affected by claims made under any other section of your policy. If any claim you make leads to a change in the price of your policy, this price change will not take effect until the next renewal after the claim and will continue for any remaining renewal period.'
    },
    PriceChangeClaimsBulletPrivateMotor: {
        id: 'SagaPlusTermsModal.PriceChangeClaimsBulletPrivateMotor',
        defaultMessage: 'You are convicted of a motoring offence or you make a claim where your insurer is unable to recover costs from a third party. Your price will not be affected by claims we have accepted as vandalism, uninsured driver, hit whilst parked, theft, fire, storm, flood, animal damage or claims for broken glass in your vehicle’s windscreen, windows or sunroof under Part 3 of the ‘loss or damage’ section of your policy. If a claim or conviction leads to a change in the price of your policy, this price change will not take effect until the next renewal after the claim or conviction and will continue for any remaining renewal period.'
    },
    PriceChangeIPTBullet: {
        id: 'SagaPlusTermsModal.PriceChangeIPTBullet',
        defaultMessage: 'There is a change to Insurance Premium Tax (IPT). Any change in IPT will be included in the insurance price for any subsequent renewals during the 3-year Fixed Price period.'
    },
    PolicyBookBulletPart1: {
        id: 'SagaPlusTermsModal.PolicyBookBulletPart1',
        defaultMessage: 'The 3-year Fixed Price and your insurance cover will be provided subject to the terms of the '
    },
    PolicyBookBulletPart2: {
        id: 'SagaPlusTermsModal.PolicyBookBulletPart2',
        defaultMessage: ', the Schedule and Endorsements to the '
    },
    PolicyBookBulletPart3: {
        id: 'SagaPlusTermsModal.PolicyBookBulletPart3',
        defaultMessage: '. Saga or the Underwriters may change the policy wording at any time. Any changes you make to your policy could result in changes to your excess (the first part of any claim that you must pay). Any change will be communicated to you in writing.'
    },
    PolicyBook: {
        id: 'SagaPlusTermsModal.PolicyBook',
        defaultMessage: 'Policy Book'
    },
    SignificantChangesBullet: {
        id: 'SagaPlusTermsModal.SignificantChangesBullet',
        defaultMessage: 'Very significant changes to your policy or to the Underwriter’s risk criteria or unfavourable insurance market conditions which materially affect the risk of insuring you may mean that Saga cannot reasonably identify an insurer who will provide insurance to you. If this is the case we will not be able to offer you cover.'
    },
    CoverNotAvailableBullet: {
        id: 'SagaPlusTermsModal.CoverNotAvailableBullet',
        defaultMessage: 'The Saga 3-year Fixed Price is not available with our {coverLevel}.'
    },
    CoversNotAvailablePrivateMotor: {
        id: 'SagaPlusTermsModal.CoversNotAvailablePrivateMotor',
        defaultMessage: 'Standard or Select cover levels'
    },
    CoversNotAvailablePrivateHome: {
        id: 'SagaPlusTermsModal.CoversNotAvailablePrivateHome',
        defaultMessage: 'Select cover level'
    },
    SagaDetailsBullet: {
        id: 'SagaPlusTermsModal.SagaDetailsBullet',
        defaultMessage: 'The Saga 3-year Fixed Price is provided by Saga Services Limited (Saga) a company registered in England with registered number 732602, whose registered office is Saga Services Limited, 3 Pancras Square, London N1C 4AG. Saga is authorised by the Financial Conduct Authority. The Saga 3-year Fixed Price is part of the service that Saga provides to you. The Saga 3-year Fixed Price is not offered to you by the panel of insurers that underwrites your insurance policy.'
    }
});
